// extracted by mini-css-extract-plugin
export default {"base":"HeaderSteps_base__FXTEr","steps":"HeaderSteps_steps__6YIKn"};